export default "__VITE_ASSET__BMs9l58p__"